exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-menu-content .ant-layout-sider-children {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n", ""]);

// exports
